var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('site-header'),_c('header-lunbo'),_c('nav-menu'),_c('div',{staticStyle:{"width":"100%","height":"70px","background":"rgba(240, 243, 248, 1)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }